<template>
  <section class="section">
    <div class="container">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Tell us about yourself</p>
        </header>

        <div class="card-content">
          <div class="content">
            <div class="columns">
              <div class="column">

                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Zip code where you grew up</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" placeholder="" name="zip" maxlength="5" pattern="\d{5}" v-model="zip"></input>
                      </div>
                      <p class="help">
                        Please input the zip code where you grew up and/or the one you think had the most influence on your speech.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                  </div>
                  <div class="field-body">
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                    <label class="label">Gender</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <div class="control">
                        <label class="radio">
                          <input type="radio" name="gender" value="m" v-model="gender">
                          Male
                        </label>
                        <label class="radio">
                          <input type="radio" name="gender" value="f" v-model="gender">
                          Female
                        </label>
                        <label class="radio">
                          <input type="radio" name="gender" value="o" v-model="gender">
                          Other
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                  </div>
                  <div class="field-body">
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Age</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select v-model="age">
                            <option></option>
                            <option v-for="age in ages">{{ age }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                  </div>
                  <div class="field-body">
                  </div>
                </div>

                <div class="field is-horizontal">
                  <div class="field-label">
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <button class="button is-success" :disabled="!canSubmit" @click="login">Start survey</button>
                        <p class="help is-danger" v-if="!canSubmit">Please enter your zip code, gender and age to continue</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from '../mylodash';
import api from '../api';

export default {
  data () {
    return {
      zip: null,
      gender: null,
      age: null,
      loadingComponent: null,
    };
  },

  computed: {
    ages () {
      return _.range(4, 120);
    },

    canSubmit () {
      return this.validZip && this.validGender && this.validAge;
    },

    validZip () {
      const regex = RegExp(/^\s*(\d{5}|\d{5}-\d{4})\s*$/);
      return regex.test(this.zip);
    },

    validGender () {
      return this.gender === 'm' || this.gender === 'f' || this.gender === 'o';
    },

    validAge () {
      const regex = RegExp(/^\d+$/);
      return regex.test(this.age);
    },

    ...mapGetters({ currentUser: 'currentUser' })
  },

  created () {
    this.checkCurrentLogin();
  },

  updated () {
    this.checkCurrentLogin();
  },

  methods: {
    checkCurrentLogin () {
      //if (this.currentUser) {
        //this.$router.replace(this.$route.query.redirect || '/authors');
      //}
    },

    login () {
      let params = {
        zip: (this.zip || '').replace(/\s+/g, ' ').trim(),
        gender: this.gender,
        age: this.age,
      };

      this.loadingComponent = this.$loading.open();

      api.postAuth(params)
        .then(request => this.loginSuccessful(request))
        .catch((error) => this.loginFailed(error));
    },

    loginSuccessful (req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }

      this.loadingComponent.close();

      localStorage.token = req.data.token;
      this.$store.dispatch('login');

      this.$router.push({ name: 'Questions' });
    },

    loginFailed (error) {
      this.loadingComponent.close();
      api.handleError(error);

      this.$store.dispatch('logout');
      delete localStorage.token;
    },
  }}
</script>

<style>
.card-header {
  background-color: #efefef;
}
</style>


// WEBPACK FOOTER //
// src/components/Start.vue